import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Heading from '@tds/core-heading';

import {
  getFormStepFieldsIoT,
  contentfulFormConfig
} from '../../../../../contentful';
import FormSummaryGroup from '../../../../../form/formSummaryGroup';
import Note from '../../../../../note';
import {
  fieldIotProductSelected,
  fieldIotActivationOrRenwal
} from '../../../../../utils/constant';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const OrderSummary = ({ orderData }) => {
  const {
    contentfulValues: {
      valueGeotab,
      valueFleetcomplete,
      valueRaven,
      valueActivation,
      valueRenewal
    }
  } = useLocalizedStringsContext();

  const [orderSummary, setOrderSummary] = useState(null);
  const config = { ...contentfulFormConfig, locale: 'en-US' };
  useEffect(() => {
    let summaryFormStepIndex = 0;
    const valueProductSelected = _.get(orderData, fieldIotProductSelected, '');
    const valueActivationOrRenwal = _.get(
      orderData,
      fieldIotActivationOrRenwal,
      ''
    );
    if (
      valueProductSelected === valueGeotab &&
      valueActivationOrRenwal === valueActivation
    )
      summaryFormStepIndex = 0;
    else if (
      valueProductSelected === valueGeotab &&
      valueActivationOrRenwal === valueRenewal
    )
      summaryFormStepIndex = 1;
    else if (
      valueProductSelected === valueFleetcomplete &&
      valueActivationOrRenwal === valueActivation
    )
      summaryFormStepIndex = 2;
    else if (
      valueProductSelected === valueFleetcomplete &&
      valueActivationOrRenwal === valueRenewal
    )
      summaryFormStepIndex = 3;
    else if (valueProductSelected === valueRaven) summaryFormStepIndex = 4;

    getFormStepFieldsIoT(config, summaryFormStepIndex, setOrderSummary);
  }, []);

  return (
    <>
      <Heading level="h3">Order Summary</Heading>
      <ExpandCollapse topDivider={false}>
        {orderSummary &&
          orderSummary.map(({ fields }) => {
            const { note, formSummaryGroup, title } = fields;
            return (
              <ExpandCollapse.Panel key={title} id={title} header={title}>
                <>
                  {note && note.content && <Note data={note} type="richText" />}
                  <FormSummaryGroup
                    data={formSummaryGroup}
                    orderData={orderData}
                  />
                </>
              </ExpandCollapse.Panel>
            );
          })}
      </ExpandCollapse>
    </>
  );
};

OrderSummary.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default OrderSummary;
